import { get } from 'lodash';
import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useDeleteRemoteLayoutMutation } from 'services/api/remoteLayout';
import { track } from 'analytics/posthog';

function DeleteModal({ name, show, onHide }) {
  const [deleteLayout, deleteLayoutState] = useDeleteRemoteLayoutMutation();

  useEffect(() => {
    if (deleteLayoutState.isSuccess) {
      track('remote layout deleted', {
        layout_name: name,
      });
      toast.success('Remote Layout deleted Successfully');
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteLayoutState.isSuccess]);

  useEffect(() => {
    if (deleteLayoutState.isError) {
      toast.error(get(deleteLayoutState, 'error.data.error'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteLayoutState.isError]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Remote Layout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you Sure you want to delete <b>{name}</b> ?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={() => deleteLayout({ name })}
          disabled={deleteLayoutState.isLoading}
        >
          Confirm
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;
